import { getDispatch } from '../get-dispatch';
import { DispatchAction } from '../utility/dispatch-action';
import {
  ConfigurationActions,
  CONFIGURATION_STATE_NAMESPACE
} from './configuration.module.types';

export const dispatchConfigurationAction: DispatchAction<ConfigurationActions> =
  getDispatch(CONFIGURATION_STATE_NAMESPACE);
